import DefaultRenderer from './default';
import filters from '../../components/filters';
import Utils from '../../util/ac-utils';
import mapboxgl from 'mapbox-gl';
import gsap from 'gsap';

class locations extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		this.mainController.destroy();

		// Utilities
		let utils = new Utils();

		// Term Click
		document.addEventListener('click', function(ev) {
			let button = ev.target;

			if (!button.matches('.term')) {
				return;
			}

			// Hide all location items
			locationItems.forEach(location => {
				location.style.display = 'none';
			});

			// Set Current Dropdown Term ID
			let placeholder = button.parentNode.previousElementSibling;
			placeholder.dataset.chosen = button.dataset.id;

			// Build string with filters query
			let classesToFilter = '';
			document.querySelectorAll('[data-chosen').forEach(filter => {
				classesToFilter += '.filter-' + filter.dataset.chosen;
			});

			// Show only filtered items
			if (document.querySelectorAll(classesToFilter).length == 0) {
				document.getElementById('locationsNoResults').style.display = 'block';
			} else {
				document.getElementById('locationsNoResults').style.display = 'none';
			}

			document.querySelectorAll(classesToFilter).forEach(location => {
				location.style.display = 'block';
			});
		});

		// // Filters
		filters('sodecia_location', null);

		// Variables
		let locationsList = document.getElementById('locations-list'),
			mapboxAcessToken =
				'pk.eyJ1IjoidGlhbnNpYWwiLCJhIjoiY2o4a2d3NWRwMGNseDMzcGZyajNhN2JkeCJ9.xiGGDW9E1zYffPFQUkXWvw',
			mapboxStyle = 'mapbox://styles/tiansial/cj8kgxbe84zyv2rquti6w95z2',
			locationItems = document.querySelectorAll('#locations-list li'),
			locations = [],
			searchResults = document.querySelectorAll('#search-results li');

		gsap.set(locationItems, { y: 20, autoAlpha: 0 });

		// Calc list height
		function calcListHeight() {
			locationsList.style.height = window.innerHeight - locationsList.getBoundingClientRect().top + 'px';

			requestAnimationFrame(calcListHeight);
		}

		requestAnimationFrame(calcListHeight);

		let activeLocation = id => {
			var activeItem = document.querySelector('.location-active');

			if (activeItem) {
				activeItem.classList.remove('location-active');
			}

			var listing = document.getElementById('location-' + id);
			listing.classList.add('location-active');
			var topPos = listing.offsetTop;
			locationsList.scrollTop = topPos - 20;
		};

		// Configure and init mapbox
		function initMapbox() {
			//Build locations with HTML data
			locationItems.forEach(item => {
				locations.push({
					id: item.dataset.locationId,
					lat: parseFloat(item.dataset.locationLat),
					lng: parseFloat(item.dataset.locationLng),
					thumbnail: item.dataset.locationThumbnail,
					type: item.querySelector('.type').innerHTML,
					title: item.querySelector('h3').innerHTML,
				});
			});

			// Init mapbox
			mapboxgl.accessToken = mapboxAcessToken;
			var map = new mapboxgl.Map({
				container: 'locations-map',
				style: mapboxStyle,
				zoom: 10,
				center: [-8.639284, 41.234009],
			});

			function createPopUp(location) {
				var popUps = document.getElementsByClassName('mapboxgl-popup'),
					locationTitle = location.title,
					locationThumbnail = location.thumbnail,
					locationType = location.type;

				// Check if there is already a popup on the map and if so, remove it
				if (popUps[0]) {
					popUps[0].remove();
				}

				new mapboxgl.Popup({ closeOnClick: false })
					.setLngLat([location.lng, location.lat])
					.setHTML(
						`${
							locationThumbnail
								? `<div class="locationThumbnail" style="background-image: url('${locationThumbnail}')"></div>`
								: ''
						}
              <div class="mapInfo">
                <span class="markerTitle">
                  ${locationTitle}
                </span>
                ${locationType ? `<span class="markerType">${locationType}</span>` : ''}
              </div>
              `,
					)
					.addTo(map);
			}

			let bounds = new mapboxgl.LngLatBounds();

			map.addControl(new mapboxgl.FullscreenControl());

			map.on('load', function() {
				// hack
				map.resize();

				// Change the cursor to a pointer when the it enters a feature in the 'symbols' layer.
				map.on('mouseenter', 'symbols', function() {
					map.getCanvas().style.cursor = 'pointer';
				});

				// Change it back to a pointer when it leaves.
				map.on('mouseleave', 'symbols', function() {
					map.getCanvas().style.cursor = '';
				});

				// Remove the labels
				map.style.stylesheet.layers.forEach(function(layer) {
					if (layer.type === 'symbol' && layer.layout['text-field']) {
						map.removeLayer(layer.id);
					}
				});

				// Create all the markers
				locations.forEach(location => {
					if (!location.lng || !location.lat) {
						return;
					}

					// define map bounds from all
					bounds.extend(new mapboxgl.LngLat(location.lng, location.lat));

					// create a DOM element for the marker
					var el = document.createElement('div'),
						locationCoordenates = [location.lng, location.lat];
					el.className = 'map-marker';
					// add marker to map
					new mapboxgl.Marker(el).setLngLat(locationCoordenates).addTo(map);

					el.addEventListener('click', function(e) {
						// 3. Highlight listing in sidebar (and remove highlight for all other listings)
						openLocation(location, locationCoordenates, location.id);
						e.stopPropagation();
					});
				});

				// define map bounds from all
				map.fitBounds(bounds);
			});

			let openLocation = (location, position, id) => {
				createPopUp(location);
				activeLocation(id);

				map.flyTo({
					center: position,
					zoom: 7,
				});
			};

			// listens to location sidebar interaction
			locationItems.forEach((item, index) => {
				item.addEventListener('click', function() {
					openLocation(
						locations[index],
						[this.dataset.locationLng, this.dataset.locationLat],
						this.dataset.locationId,
					);
				});
			});

			searchResults.forEach((item, index) => {
				let itemToToggle = document.querySelector('li[data-location-id="' + item.dataset.id + '"]');
				let itemCoordenates = [
					parseFloat(itemToToggle.dataset.locationLng),
					parseFloat(itemToToggle.dataset.locationLat),
				];
				item.addEventListener('click', function() {
					openLocation(locations[index], itemCoordenates, item.dataset.id);
				});
			});
		}

		if (!utils.isMobile()) {
			initMapbox();
		} else {
			locationItems.forEach(item => {
				item.addEventListener('click', function() {
					activeLocation(item.dataset.locationId);
				});
			});
		}
	}

	onEnterCompleted() {
		super.onEnterCompleted();
		let locationItems = document.querySelectorAll('#locations-list li');
		gsap.to(locationItems, {
			duration: 1.5,
			y: 0,
			ease: 'power4.out',
			autoAlpha: 1,
			stagger: 0.1,
		});
	}

	onLeave() {
		super.onLeave();
	}
}

export default locations;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/locations.js